<template>
    <!-- INFO: Do not use with.bind when using <slot>. Slot does not render. -->

    <div class="col-12 col-lg-6 pe-lg-2 form-group">
        <label for="referral-address-line-2">
            Country
            <span class="text-danger">*</span>
        </label>
        <CountryTypeahead
            :selected-country-prop="selectedCountry"
            :updateSelectedCountry="updateSelectedCountry"
            v-model:prefill-country="address.country"
            v-model:prefill-country-name="autoCompleteCountry"
            :disabled="selectedFacility"
        >
        </CountryTypeahead>
    </div>
    <div class="w-100"></div>
    <div class="col-12 col-lg-6 pe-lg-2 form-group">
        <label for="referral-address-line-1">
            Address Line 1
            <span class="text-danger">*</span>
        </label>
        <!-- Review this component and every prop -->
        <PlacesAutocomplete
            v-model:street="address.addressLine1"
            v-model:city="address.city"
            v-model:state="address.state"
            v-model:zip="address.zipCode"
            v-model:county="address.county"
            v-model:latitude="address.latitude"
            v-model:longitude="address.longitude"
            v-model:disabled="selectedFacility"
            v-model:country="autoCompleteCountry"
            v-on:blurredInput="v$.address.addressLine1.$touch()"
            :places-changed-call-back="placesChangedCallBack"
            :class="`${!v$.address.addressLine1.$error ? '' : 'field-invalid'}`"
            v-model:isValidatedAndByPassToggled="address.isValidatedAndByPassToggled"
        >
        </PlacesAutocomplete>
        <span v-if="v$.address.addressLine1.$error" class="field-invalid">Address Line 1 is required.</span>
    </div>
    <div class="col-12 col-lg-6 pe-lg-2 form-group">
        <label for="referral-address-line-2"> Address Line 2 </label>
        <input
            class="form-control"
            maxlength="50"
            type="text"
            v-model="address.addressLine2"
            placeholder="Enter Address Line 2"
        />
    </div>
    <div class="w-100"></div>
    <div class="col-12 col-lg-4 pe-lg-2 form-group">
        <label for="referral-city">
            City/Town
            <span class="text-danger">*</span>
        </label>
        <input
            class="form-control"
            maxlength="50"
            type="text"
            v-model="address.city"
            placeholder="Enter City/Town"
            :disabled="selectedFacility"
            :class="`${!v$.address.city.$error ? '' : 'field-invalid'}`"
            @blur="v$.address.city.$touch"
        />
        <span v-if="v$.address.city.$error" class="field-invalid">City/Town is required.</span>
    </div>
    <div class="col-12 col-lg-4 pe-lg-2 form-group">
        <label for="referral-state">
            {{ isUnitedStates ? "State" : "State / Province / Territory" }}
            <span class="text-danger" v-if="isUnitedStates">*</span>
        </label>
        <StateTypeahead
            v-model:selected-state="selectedState"
            v-model:prefill-state="address.state"
            :disabled="selectedFacility"
            v-on:updateSelectedState="updateSelectedState"
            v-if="isUnitedStates"
            :class="`${!v$.address.state.$error ? '' : 'field-invalid'}`"
            v-on:blurredInput="v$.address.state.$touch()"
        />

        <input
            class="form-control"
            maxlength="50"
            type="text"
            v-model="address.state"
            placeholder="Enter State / Province / Territory"
            :disabled="selectedFacility"
            @blur="v$.address.state.$touch"
            :class="`${!v$.address.state.$error ? '' : 'field-invalid'}`"
            v-else
        />
        <span v-if="v$.address.state.$error" class="field-invalid">State is required.</span>
    </div>
    <div class="col-12 col-lg-4 pe-lg-2 form-group">
        <label for="referral-zip">
            Postal Code
            <span class="text-danger">*</span>
        </label>
        <input
            class="form-control"
            maxlength="10"
            type="text"
            v-number-only
            :value="formatZipCode(address.zipCode)"
            @input="(e) => handleZipcodeChange(e)"
            placeholder="Enter Zip"
            @blur="v$.address.zipCode.$touch"
            :class="`${!v$.address.zipCode.$error ? '' : 'field-invalid'}`"
            :disabled="selectedFacility"
            v-if="isUnitedStates"
        />
        <input
            class="form-control"
            maxlength="9"
            type="text"
            v-model="address.zipCode"
            placeholder="Enter Postal Code"
            @blur="v$.address.zipCode.$touch"
            :class="`${!v$.address.zipCode.$error ? '' : 'field-invalid'}`"
            :disabled="selectedFacility"
            v-else
        />
        <span v-if="v$.address.zipCode.$error" class="field-invalid">Postal Code is required.</span>
    </div>
</template>

<script lang="ts" src="./ReferralAddressForm.ts"></script>
